import React from "react";
import { Calendar, ChevronDown } from "lucide-react";

interface DateRangeFilterProps {
  selectedDays: number;
  onDaysChange: (days: number) => void;
  isLoading?: boolean;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  selectedDays,
  onDaysChange,
  isLoading = false,
}) => {
  const dayOptions = [
    { value: 1, label: "Last 1 day" },
    { value: 7, label: "Last 7 days" },
    { value: 14, label: "Last 14 days" },
    { value: 30, label: "Last 30 days" },
    { value: 60, label: "Last 60 days" },
    { value: 90, label: "Last 90 days" },
  ];

  const getSelectedLabel = () => {
    const option = dayOptions.find((opt) => opt.value === selectedDays);
    return option ? option.label : `Last ${selectedDays} days`;
  };

  return (
    <div className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Date Range Filter
      </label>
      <div className="relative">
        <select
          value={selectedDays}
          onChange={(e) => onDaysChange(parseInt(e.target.value))}
          disabled={isLoading}
          className="appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed min-w-[180px]"
        >
          {dayOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <ChevronDown className="h-4 w-4 text-gray-400" />
        </div>
      </div>
      <div className="flex items-center gap-2 mt-2 text-xs text-gray-500">
        <Calendar className="h-3 w-3" />
        <span>{getSelectedLabel()}</span>
      </div>
    </div>
  );
};

export default DateRangeFilter;
